import React, { useState } from "react";
import "./AccountSetting.css";
import { Tabs, Switch, Input, Button } from "antd";

const AccountSetting = () => {
  const [emailNews, setEmailNews] = useState(true);
  const [inAppNotification, setInAppNotification] = useState(true);
  const [promotionAlerts, setPromotionAlerts] = useState(false);
  const [teacherNotification, setTeacherNotification] = useState(true);
  
  const handleSwitchChange = (setter) => (checked) => {
    setter(checked);
  };

  return (
    <div className="account-setting-container">
      <div className='account-setting-layout'>
        <h1 className="account-setting-title">Account Settings</h1>
        <Tabs defaultActiveKey="1">
          <Tabs.TabPane tab="Personal Info" key="1">
            <div className="account-form">
              <div className="form-group">
                <label>Email Address</label>
                <Input type="email" value="sophiaHussein@example.com" disabled  style={{ height: 40 }}/>
              </div>
              <div className="form-group">
                <label>Phone Number</label>
                <Input type="tel" placeholder="Enter your phone number" style={{ height: 40 }}/>
              </div>
              <Button type="primary">Save Changes</Button>
            </div>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Change Password" key="2">
            <div className="account-form">
              <div className="form-group">
                <label>Current Password</label>
                <Input.Password placeholder="Enter current password" style={{ height: 40 }} />
              </div>
              <div className="form-group">
                <label>New Password</label>
                <Input.Password placeholder="Enter new password"  style={{ height: 40 }}/>
              </div>
              <div className="form-group">
                <label>Confirm Password</label>
                <Input.Password placeholder="Confirm new password"  style={{ height: 40 }}/>
              </div>
              <Button type="primary">Change Password</Button>
            </div>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Notifications" key="3">
            <div className="notification-settings">
              <div className="notification-item">
                <span>Email News Notifications</span>
                <Switch checked={emailNews} onChange={handleSwitchChange(setEmailNews)} />
              </div>
              <div className="notification-item">
                <span>In-App Notifications</span>
                <Switch checked={inAppNotification} onChange={handleSwitchChange(setInAppNotification)} />
              </div>
              <div className="notification-item">
                <span>Promotion Alerts</span>
                <Switch checked={promotionAlerts} onChange={handleSwitchChange(setPromotionAlerts)} />
              </div>
              <div className="notification-item">
                <span>Teacher Notifications</span>
                <Switch checked={teacherNotification} onChange={handleSwitchChange(setTeacherNotification)} />
              </div>
            </div>
          </Tabs.TabPane>
        </Tabs>
      </div>
    </div>
  );
};

export default AccountSetting;
